export default __webpack_public_path__ + "static/media/ARQ.PLAN PDF.d64c2b27.pdf";